import DateTime, { type ITimeZone } from '@dealroadshow/uikit-date-time';
import type { IDatetime } from '@framework/date-helpers/Datetime';

/**
 * Recovers the true instant from a `TimeStampWithTimeZone` payload, whose `dateTime` is a wall
 * clock stamped `+0000` rather than a UTC instant - `timezone` names the zone it belongs to.
 *
 * Only for payloads proven to carry a wall clock, not ones storing a real instant.
 */
export const toRecordInstant = (cellData: IDatetime | null | undefined): DateTime | null => {
  if (!cellData?.dateTime || !cellData.timezone) {
    return null;
  }

  const asSent = new DateTime(cellData.dateTime);

  if (Number.isNaN(asSent.getTime())) {
    return null;
  }

  // `dateTime` carries a +0000 offset, so its UTC fields are the wall clock verbatim.
  return new DateTime(0, { timeZone: cellData.timezone as ITimeZone }).set({
    year: asSent.getUTCFullYear(),
    month: asSent.getUTCMonth(),
    date: asSent.getUTCDate(),
    hours: asSent.getUTCHours(),
    minutes: asSent.getUTCMinutes(),
    seconds: asSent.getUTCSeconds(),
    milliseconds: asSent.getUTCMilliseconds(),
  });
};

export const formatRecordTimestamp = (
  cellData: IDatetime | null | undefined,
  format: string,
  viewerZone: ITimeZone,
): string | null => {
  const instant = toRecordInstant(cellData);

  if (!instant) {
    return null;
  }

  instant.setTimeZone(viewerZone);

  return instant.format(format);
};
